import { IDeliveryLimitations } from '../../../models/parcelDimensions';
import { ParcelDimensions } from '../../../models/shipmentCountryInfo';
import { Measure } from '../../../utils/parcel-measurements.ts/parcel-measurements-utils';
import { isAnyValueEmpty } from '../../../utils/generic/generic.utils';
import { calculateVolumetricWeight } from './dimensionsConfig';

interface UseVolumetricWeightProps {
  deliveryLimitations?: IDeliveryLimitations;
  isOnlyWeightValidation: boolean;
  measures: Measure;
  parcelDimensions: ParcelDimensions | null;
}

const useVolumetricWeight = ({
  deliveryLimitations,
  isOnlyWeightValidation,
  measures,
  parcelDimensions,
}: UseVolumetricWeightProps) => {
  const allInputsProvided = !isAnyValueEmpty(parcelDimensions);

  const volumetricWeight =
    parcelDimensions && !isOnlyWeightValidation
      ? calculateVolumetricWeight({
          length: parcelDimensions.size_x,
          width: parcelDimensions.size_y,
          height: parcelDimensions.size_z,
          measure: measures,
        })
      : 0;

  const isVolumetricWeightTooLarge =
    allInputsProvided && parcelDimensions && !isOnlyWeightValidation
      ? volumetricWeight > parcelDimensions.weight
      : false;

  const shouldShowVolumetricError =
    deliveryLimitations?.maxVolWeight &&
    !isOnlyWeightValidation &&
    volumetricWeight > deliveryLimitations.maxVolWeight;

  const volWeightNumber = Number.isInteger(volumetricWeight)
    ? volumetricWeight
    : volumetricWeight.toFixed(2);

  const shouldShowVolWeight =
    !isOnlyWeightValidation &&
    allInputsProvided &&
    parcelDimensions &&
    volumetricWeight > parcelDimensions.weight;

  return {
    isVolumetricWeightTooLarge,
    shouldShowVolumetricError,
    shouldShowVolWeight,
    volWeightNumber,
    volumetricWeight,
  };
};

export default useVolumetricWeight;
